import React from "react";
import { Link } from "react-router-dom";
import SEO from "@/components/SEO";
import { Phone, Mail, MapPin } from "lucide-react";

const ImpressumPage = () => {
  return (
    <>
      <SEO 
        title="Impressum"
        description="Impressum der BIS GmbH - Kfz Gutachter Schmeißer. Angaben gemäß § 5 TMG. Kontaktdaten und rechtliche Informationen."
        canonical="/impressum"
      />
      {/* Hero */}
      <section className="bg-[#F7F7F7] py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-4xl font-black text-black mb-4 font-['Outfit']">Impressum</h1>
          <p className="text-[#4A4A4A]">Angaben gemäß § 5 TMG</p>
        </div>
      </section>

      {/* Content */}
      <section className="py-16 bg-white">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="prose prose-lg max-w-none">
            
            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-4 font-['Outfit']">Anbieter</h2>
              <div className="bg-[#F7F7F7] p-6 rounded-sm">
                <p className="text-[#4A4A4A] mb-4">
                  <strong className="text-black">BIS GmbH</strong><br />
                  Heidweg 1d<br />
                  25436 Uetersen<br />
                  Deutschland
                </p>
                <div className="flex flex-col space-y-2">
                  <a href="tel:+491748936514" className="flex items-center text-[#AA6622] hover:underline">
                    <Phone className="w-4 h-4 mr-2" />
                    +49 174 893 6514
                  </a>
                  <a href="mailto:info@bis-kfz-gutachten.de" className="flex items-center text-[#AA6622] hover:underline">
                    <Mail className="w-4 h-4 mr-2" />
                    info@bis-kfz-gutachten.de
                  </a>
                </div>
              </div>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-4 font-['Outfit']">Vertreten durch</h2>
              <p className="text-[#4A4A4A]">
                Geschäftsführerin: Sabine Eva Niklas
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-4 font-['Outfit']">Bildquellen</h2>
              <p className="text-[#4A4A4A]">
                Die auf dieser Website verwendeten Bilder stammen von:
              </p>
              <ul className="list-disc list-inside text-[#4A4A4A] mt-2">
                <li>pixabay.com</li>
                <li>pexels.com</li>
                <li>canva.com</li>
              </ul>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-4 font-['Outfit']">Haftung für Inhalte</h2>
              <p className="text-[#4A4A4A]">
                Als Diensteanbieter sind wir gemäß § 7 Abs.1 TMG für eigene Inhalte auf diesen Seiten nach den 
                allgemeinen Gesetzen verantwortlich. Nach §§ 8 bis 10 TMG sind wir als Diensteanbieter jedoch 
                nicht verpflichtet, übermittelte oder gespeicherte fremde Informationen zu überwachen oder nach 
                Umständen zu forschen, die auf eine rechtswidrige Tätigkeit hinweisen.
              </p>
              <p className="text-[#4A4A4A] mt-4">
                Verpflichtungen zur Entfernung oder Sperrung der Nutzung von Informationen nach den allgemeinen 
                Gesetzen bleiben hiervon unberührt. Eine diesbezügliche Haftung ist jedoch erst ab dem Zeitpunkt 
                der Kenntnis einer konkreten Rechtsverletzung möglich. Bei Bekanntwerden von entsprechenden 
                Rechtsverletzungen werden wir diese Inhalte umgehend entfernen.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-4 font-['Outfit']">Haftung für Links</h2>
              <p className="text-[#4A4A4A]">
                Unser Angebot enthält Links zu externen Webseiten Dritter, auf deren Inhalte wir keinen Einfluss 
                haben. Deshalb können wir für diese fremden Inhalte auch keine Gewähr übernehmen. Für die Inhalte 
                der verlinkten Seiten ist stets der jeweilige Anbieter oder Betreiber der Seiten verantwortlich. 
                Die verlinkten Seiten wurden zum Zeitpunkt der Verlinkung auf mögliche Rechtsverstöße überprüft. 
                Rechtswidrige Inhalte waren zum Zeitpunkt der Verlinkung nicht erkennbar.
              </p>
              <p className="text-[#4A4A4A] mt-4">
                Eine permanente inhaltliche Kontrolle der verlinkten Seiten ist jedoch ohne konkrete Anhaltspunkte 
                einer Rechtsverletzung nicht zumutbar. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige 
                Links umgehend entfernen.
              </p>
            </div>

            <div className="mb-12">
              <h2 className="text-2xl font-bold text-black mb-4 font-['Outfit']">Urheberrecht</h2>
              <p className="text-[#4A4A4A]">
                Die durch die Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten unterliegen dem 
                deutschen Urheberrecht. Die Vervielfältigung, Bearbeitung, Verbreitung und jede Art der Verwertung 
                außerhalb der Grenzen des Urheberrechtes bedürfen der schriftlichen Zustimmung des jeweiligen 
                Autors bzw. Erstellers. Downloads und Kopien dieser Seite sind nur für den privaten, nicht 
                kommerziellen Gebrauch gestattet.
              </p>
              <p className="text-[#4A4A4A] mt-4">
                Soweit die Inhalte auf dieser Seite nicht vom Betreiber erstellt wurden, werden die Urheberrechte 
                Dritter beachtet. Insbesondere werden Inhalte Dritter als solche gekennzeichnet. Sollten Sie 
                trotzdem auf eine Urheberrechtsverletzung aufmerksam werden, bitten wir um einen entsprechenden 
                Hinweis. Bei Bekanntwerden von Rechtsverletzungen werden wir derartige Inhalte umgehend entfernen.
              </p>
            </div>

            <div className="mb-12 bg-[#F7F7F7] p-4 rounded-sm">
              <p className="text-sm text-[#6B7280]">
                Quelle: eRecht24
              </p>
            </div>

          </div>
        </div>
      </section>

      {/* CTA */}
      <section className="py-12 bg-[#F7F7F7]">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <p className="text-[#4A4A4A] mb-4">Haben Sie Fragen?</p>
          <Link 
            to="/kontakt"
            className="inline-flex items-center px-6 py-3 bg-[#AA6622] text-white font-semibold rounded-sm hover:bg-[#8B5319] transition-colors"
          >
            Kontakt aufnehmen
          </Link>
        </div>
      </section>
    </>
  );
};

export default ImpressumPage;
